import { Button, Typography } from '@breetometer/components';
import { yupResolver } from '@hookform/resolvers/yup';
import { PasswordInput } from 'BreetComponents';
import { capitalizeFirstLetter, handleApiError } from 'BreetHelpers';
import { useVerifyPasswordMutation } from 'BreetRedux';
import { useCallback } from 'react';
import { useForm } from 'react-hook-form';

import { type IVerifyPassword, VerificationPasswordSchema, type VerificationPasswordSchemaType } from './PinManagement.helpers';

const VerifyPassword = ({ onPasswordVerified }: IVerifyPassword) => {
	const [verifyPassword, { isLoading }] = useVerifyPasswordMutation();

	const {
		handleSubmit,
		formState: { errors, isValid },
		register,
	} = useForm<VerificationPasswordSchemaType>({
		resolver: yupResolver(VerificationPasswordSchema),
	});

	const handlePasswordVerification = useCallback(
		(data: VerificationPasswordSchemaType) => {
			verifyPassword({ password: data.password })
				.unwrap()
				.then(() => {
					onPasswordVerified();
				})
				.catch(handleApiError);
		},
		[onPasswordVerified, verifyPassword]
	);

	return (
		<form
			className='securityverifypassword'
			onSubmit={handleSubmit(handlePasswordVerification)}
		>
			<div className='securityverifypassword_header'>
				<Typography
					as='h1'
					className='color-neutral-50'
				>
					Enter your password
				</Typography>
				<Typography className='color-primary-100'>Verify your password to continue.</Typography>
			</div>
			<PasswordInput
				id=''
				label='Password'
				widthType='full'
				{...register('password')}
				errorMessage={capitalizeFirstLetter(errors.password?.message)}
				// eslint-disable-next-line jsx-a11y/no-autofocus
				autoFocus
				required
			/>
			<Button
				label='Continue'
				disabled={!isValid}
				isLoading={isLoading}
				className='primary-hover'
			/>
		</form>
	);
};

export default VerifyPassword;
